<template>
  <div></div>
</template>
<script>
import protoComponent from './proto'
import { wgs2gcj, gcj2wgs } from '@/util/map/proj'

export default {
  name: 'SlAmapMarker',
  extends: protoComponent,
  data() {
    return {}
  },

  props: {
    center: {
      type: Array,
      class: 'latlng'
    },
    cs: {
      type: String,
      default: 'gcj02'
    }
  },
  methods: {
    $initComponent(options) {
      this.marker = new AMap.Marker({
        position: this.$amap.getCenter(),
        content: '<div class="sl-amap-marker-default"></div>',
        offset: new AMap.Pixel(-13, -30)
      });

      this.marker.setMap(this.$amap);

      return this.marker
    },
    $setCenter(v) {
      console.log(v)
      this.$amap.setCenter(v)
      this.marker.setPosition(v)
    },
    $convCenter(v) {
      if (v) {
        return new AMap.LngLat(...(this.cs == 'wgs84' ? wgs2gcj(...v) : v))
      } else {
        return undefined
      }
    }
  },
  destroyed() {

  }
};

</script>
